import React from "react";

const Footer = () => {
  return (
    <div className="flex items-center justify-center text-white p-4 gap-2 ">
      <div className="text-[0.9rem] text-blue">
        &#169; BookOfDelvin, LLC. All Rights Reserved.
      </div>
    </div>
  );
};

export default Footer;